import { theme } from '@blueprinthq/joy'

export const COLORS = {
  GREEN: theme.colors.success,
  RED: theme.colors.pink,
  GRAY: theme.colors.medium_gray,
  BLUE: theme.colors.blue['500']
}
